// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigations_navigations__iANs3 {
    position: fixed;
    bottom: 10px;
    /* display:flex;
    justify-content: center;
align-items: center; */
width: 100%;
/* max-width: 400px; */
   
}
    
.Navigations_wrapper__bQlNz {
display:flex;
gap:10px;
justify-content: center;
align-items: center;
}

.Navigations_button__G4ZYl {
    background-color: #ffc843;
    opacity: 30%;
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    color: #161616;
    min-width: 100px;
    border: 1px solid #161616;
    /* transition: all 0.3s ease; */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    font-weight: bold;
}

.Navigations_buttonActive__B1eqU {
    background-color: #ffc843;
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    color: #161616;
    min-width: 100px;
    border: 1px solid #161616;
    /* transition: all 0.3s ease; */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    font-weight: bold;
}

.Navigations_btnIcon__WLvn8 {
    width: 30px;
    height: 30px;
    
}

.Navigations_text__4EWzV {
    padding-top: 5px;
    padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Navigations/Navigations.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ;;sBAEkB;AACtB,WAAW;AACX,sBAAsB;;AAEtB;;AAEA;AACA,YAAY;AACZ,QAAQ;AACR,uBAAuB;AACvB,mBAAmB;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,+BAA+B;IAC/B,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,+BAA+B;IAC/B,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".navigations {\n    position: fixed;\n    bottom: 10px;\n    /* display:flex;\n    justify-content: center;\nalign-items: center; */\nwidth: 100%;\n/* max-width: 400px; */\n   \n}\n    \n.wrapper {\ndisplay:flex;\ngap:10px;\njustify-content: center;\nalign-items: center;\n}\n\n.button {\n    background-color: #ffc843;\n    opacity: 30%;\n    border-radius: 5px;\n    padding: 5px;\n    text-align: center;\n    color: #161616;\n    min-width: 100px;\n    border: 1px solid #161616;\n    /* transition: all 0.3s ease; */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    font-weight: bold;\n}\n\n.buttonActive {\n    background-color: #ffc843;\n    border-radius: 5px;\n    padding: 5px;\n    text-align: center;\n    color: #161616;\n    min-width: 100px;\n    border: 1px solid #161616;\n    /* transition: all 0.3s ease; */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    font-weight: bold;\n}\n\n.btnIcon {\n    width: 30px;\n    height: 30px;\n    \n}\n\n.text {\n    padding-top: 5px;\n    padding-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigations": `Navigations_navigations__iANs3`,
	"wrapper": `Navigations_wrapper__bQlNz`,
	"button": `Navigations_button__G4ZYl`,
	"buttonActive": `Navigations_buttonActive__B1eqU`,
	"btnIcon": `Navigations_btnIcon__WLvn8`,
	"text": `Navigations_text__4EWzV`
};
export default ___CSS_LOADER_EXPORT___;
